import { useSyncExternalStore } from 'react';

// Small hook to read the current admin role from localStorage.
// Re-renders when the value changes (via the storage event or setAdminRole helper).
const subscribe = (cb) => {
  window.addEventListener('storage', cb);
  window.addEventListener('admin-role-change', cb);
  return () => {
    window.removeEventListener('storage', cb);
    window.removeEventListener('admin-role-change', cb);
  };
};

const getSnapshot = () => localStorage.getItem('admin_role') || 'admin';

export const useAdminRole = () => useSyncExternalStore(subscribe, getSnapshot, () => 'admin');

export const isSuperAdmin = () => (localStorage.getItem('admin_role') || 'admin') === 'super_admin';
